import styled from 'styled-components';

import { getType, getEllipsis, getSizeResponsiveness } from './helpers';

import { transparentize } from 'polished';
import { HTMLAttributes } from 'react';
import { Colors, TextType } from '../types';

type Props = {
    $opacityValue: number;
    $text?: string;
    $type?: TextType;
    $color?: Colors;
    $uppercase?: boolean;
    $bold?: boolean;
    $center?: boolean;
    $mb?: number;
    $mt?: number;
    $ellipsis?: number;
    $italic?: boolean;
    $underline?: boolean;
    $inline?: boolean;
    $medium?: boolean;
} & HTMLAttributes<HTMLParagraphElement>;

export const StyledText = styled.p<Props>`
    font-family: 'Roboto', sans-serif;
    color: ${({ $color = 'text-main', theme, $opacityValue }) =>
        $opacityValue && theme[$color] ? transparentize($opacityValue, theme[$color]) : theme[$color]};
    ${({ theme, $type }) => getType(theme, $type)};
    ${({ $ellipsis, $type }) => $ellipsis && getEllipsis($ellipsis, $type)};
    ${getSizeResponsiveness}
    ${({ $center }) => $center && 'text-align: center;'};
    ${({ $uppercase }) => $uppercase && 'text-transform: uppercase;'};
    ${({ $bold }) => $bold && 'font-weight: 700;'};
    ${({ $italic }) => $italic && 'font-style: italic;'};
    ${({ $underline }) => $underline && 'text-decoration: underline;'};
    ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`};
    ${({ $mt }) => $mt && `margin-top: ${$mt}px;`};
    ${({ $inline }) => $inline && 'display: inline'};
    ${({ $medium }) => $medium && 'font-weight: 500'};
`;
